import { useEffect, useState } from "react";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);
    mediaQueryList.addEventListener("change", listener);
    return () => mediaQueryList.removeEventListener("change", listener);
  }, [query]);

  return matches;
}

const DESKTOP_QUERY = "(min-width: 768px)";

export const useIsDesktop = (): boolean => useMediaQuery(DESKTOP_QUERY);
export const useIsMobile = (): boolean => !useMediaQuery(DESKTOP_QUERY);
